import { RouteName } from '@mews-commander/enums';
import { GuestProfile } from '@mews-commander/guest-profile';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { useGainsightService } from '@mews/framework';
import { useResolveRoute } from '@mews/routing';
import { openModal } from '../../../../../../../../modules/app';
import { MatchAndMergeGainSightEvents } from '../../../../../GainSightEvents';

type useOpenGuestProfileParams = Pick<GuestProfile, 'id'>;

export const useOpenGuestProfile = ({ id }: useOpenGuestProfileParams) => {
    const gainSightService = useGainsightService();
    const dispatch = useCommanderThunkDispatch();
    const resolveRoute = useResolveRoute();
    const url = resolveRoute(RouteName.CustomerDetail, { id });

    return () => {
        gainSightService.trackEvent(MatchAndMergeGainSightEvents.MatchAndMergeNavigatedToCustomerProfile, {
            customerId: id,
        });
        dispatch(openModal(url));
    };
};
